import { AxiosError } from 'axios'

export const removeEmpty = (obj: any, depth = 1) => {
  const newObj: any = {};

  Object.keys(obj).forEach((key) => {
    if (obj[key] && typeof obj[key] === 'object' && depth > 1) {
      newObj[key] = removeEmpty(obj[key]); // recurse
    } else if (obj[key] != null && obj[key] !== '') {
      newObj[key] = obj[key]; // copy value
    }
  });

  return newObj;
};

/**
 * Recursive function of accessing index
 * @param obj Object to be access
 * @param is Array of key
 */
export function multiIndex(obj: any, is: string[]): string {
  return is.length ? multiIndex(obj[is[0]], is.slice(1)) : obj;
}

/**
 * Return value of object by nested key
 * @param obj Object to be access
 * @param is key path
 * @return result
 */
export function pathIndex<T = any>(obj: T, is: string) {
  // console.log(obj);
  try {
    return multiIndex(obj, is.split('.')) || '';
  } catch {
    return '';
  }
}

/**
 * Default fields to search data
 */
const DEFAULT_FIELDS = ['firstName', 'lastName', 'position', 'company.name', 'email'];

/**
 * 
 * @param d data
 * @param searchTerm search text
 * @param fields fields to search
 * @returns 
 */
export const searchFn = <T = any>(d: T[], searchTerm: string, fields: string[] = []) => {
  const _fields = fields.length > 0
    ? fields
    : DEFAULT_FIELDS;
  return d.filter((i) =>
    _fields.some((f: any) =>
      pathIndex(i, f)
        .toLowerCase()
        .includes(searchTerm.toLowerCase())));
};

export const errorMessage = (err: AxiosError): string => {
  const { message, response: { data: { message: responseMessage = '' } = {} } = {} } = err;
  return responseMessage || message;
};

interface Document {
  createdAt?: Date
  updatedAt?: Date
}

export const sortByDate = (a: Document, b: Document) => new Date(b.createdAt).valueOf() - new Date(a.createdAt).valueOf();

export const buildURLQuery = <T = any>(obj: T) =>
  Object.entries(obj)
    .map((pair) => pair.map(encodeURIComponent).join('='))
    .join('&');
